import { render } from "./vcorporatetransferbankcardlist.vue?vue&type=template&id=eb4c61cc&scoped=true"
import script from "./vcorporatetransferbankcardlist.vue?vue&type=script&lang=js"
export * from "./vcorporatetransferbankcardlist.vue?vue&type=script&lang=js"

import "./vcorporatetransferbankcardlist.vue?vue&type=style&index=0&id=eb4c61cc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4c61cc"]])

export default __exports__